import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";
import BaseModalView from "./base-modal-view"


@Options({
    template: require("../templates/benefits-series-view.njk"),

})
export default class BenefitsSeriesView extends Marionette.View<Backbone.Model>{ }



// WEBPACK FOOTER //
// ./@modules/modals/views/benefits-series-view.ts